"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var en_1 = require("../locales/en");
var zh_1 = require("../locales/zh");
var settings_1 = require("./settings");
var resources = {
    en: {
        translation: en_1.en
    },
    zh: {
        translation: zh_1.zh
    }
};
var language = settings_1.REGION === 'CN' ? 'zh' : 'en';
// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next_1.default
    .use(react_i18next_1.initReactI18next) // passes i18n down to react-i18next
    .init({
    resources: resources,
    lng: language,
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});
exports.default = i18next_1.default;
